import { render, staticRenderFns } from "./si_maze_triangular.vue?vue&type=template&id=7a2b956e&scoped=true&"
import script from "./si_maze_triangular.vue?vue&type=script&lang=js&"
export * from "./si_maze_triangular.vue?vue&type=script&lang=js&"
import style0 from "./si_maze_triangular.vue?vue&type=style&index=0&id=7a2b956e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2b956e",
  null
  
)

export default component.exports